/**
* 供货管理 供货退货管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <div class="mt20">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我供货的" name="first">
          <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.settle_company_name" placeholder="请输入商家名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.service_code" placeholder="服务单号" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.order_code" placeholder="订单编号" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.keywords" placeholder="商品编码/名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline.audit_status" placeholder="审核状态" clearable>
                <el-option label="未审核" value="260"></el-option>
                <el-option label="审核通过" value="261"></el-option>
                <el-option label="审核未通过" value="262"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline.process_status" placeholder="请选择售后状态" clearable>
                <el-option label="已取消" value="250"></el-option>
                <el-option label="提交申请" value="251"></el-option>
                <el-option label="审计" value="252"></el-option>
                <el-option label="收货" value="253"></el-option>
                <el-option label="退款" value="254"></el-option>
                <el-option label="完成" value="255"></el-option>
                <el-option label="出库" value="256"></el-option>
                <el-option label="维修中" value="257"></el-option>
                <el-option label="待出货" value="258"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline.settle_status" placeholder="请选择结算状态" clearable>
                <el-option label="已结算" value="1"></el-option>
                <el-option label="未结算" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search">查询</el-button>
              <el-button size="small" type="warning" @click="getOrder">结算退货单</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                      @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                      element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column align="center" type="selection" width="60">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="制单时间" width="150">
                <template slot-scope="scope">
                  <div>{{scope.row.create_time|timestampToTime}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="service_code" label="服务单号" min-width="150" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <span style="color: #1989FA;cursor: pointer" @click="gotoAftersaleDetail(scope.row.id)">
                    {{scope.row.service_code}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="seller_name" label="商家名称" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_code" label="商品编码" width="150" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_name" label="产品名称" width="150" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="order_code" label="订单编号" width="150" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="num" label="售后数量" width="120" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="service_money" label="售后金额" width="120" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.service_money||scope.row.service_money==0">￥{{scope.row.service_money}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="service_type" label="服务类型" width="100" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.service_type==90">退货</div>
                  <div v-else-if="scope.row.service_type==91">挂账</div>
                  <div v-else-if="scope.row.service_type==93">代发退货</div>
                  <div v-else>维修</div>
                </template>
              </el-table-column>
              <el-table-column prop="process_status" label="售后处理状态" width="100" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.process_status==250">已取消</div>
                  <div v-else-if="scope.row.process_status==251">提交申请</div>
                  <div v-else-if="scope.row.process_status==252">审计</div>
                  <div v-else-if="scope.row.process_status==253">收货</div>
                  <div v-else-if="scope.row.process_status==254">退款</div>
                  <div v-else-if="scope.row.process_status==255">完成</div>
                  <div v-else-if="scope.row.process_status==256">出库</div>
                  <div v-else-if="scope.row.process_status==257">维修中</div>
                  <div v-else>待出货</div>
                </template>
              </el-table-column>
              <el-table-column prop="audit_status" label="审核状态" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.audit_status==260">未审核</div>
                  <div v-else-if="scope.row.audit_status==261">审核通过</div>
                  <div v-else>审核不通过</div>
                </template>
              </el-table-column>
              <el-table-column prop="audit_name" label="审核人" width="100" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="settle_status" label="结算状态" width="100">
                <template slot-scope="scope">
                  <div plain v-if="scope.row.settle_status==1">已结算</div>
                  <div plain v-else>未结算</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" min-width="150">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="receiptForm(scope.row.id)"
                             v-if="scope.row.is_show_luru_btn">确认收货
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-tab-pane>

        <!-- 给我供货 -->
        <el-tab-pane label="给我供货" name="second" v-if="agent_type == '2891'">
          <el-form :inline="true" :model="formInline1" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate1"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.supply_seller_name" placeholder="请输入供应商名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.service_code" placeholder="服务单号" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.order_code" placeholder="订单编号" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.product_code" placeholder="商品编码/名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline1.audit_status" placeholder="审核状态" clearable>
                <el-option label="未审核" value="260"></el-option>
                <el-option label="审核通过" value="261"></el-option>
                <el-option label="审核未通过" value="262"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline1.process_status" placeholder="请选择售后状态" clearable>
                <el-option label="已取消" value="250"></el-option>
                <el-option label="提交申请" value="251"></el-option>
                <el-option label="收货" value="253"></el-option>
                <el-option label="维修中" value="257"></el-option>
                <el-option label="待出货" value="258"></el-option>
                <el-option label="退款" value="254"></el-option>
                <el-option label="完成" value="255"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline1.settle_status" placeholder="请选择结算状态" clearable>
                <el-option label="已结算" value="1"></el-option>
                <el-option label="未结算" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search1">查询</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border
                      @cell-dblclick="cellDbClick" element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column align="center" type="selection" width="60">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm1.pageSize * (pageparm1.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="制单时间" width="150">
                <template slot-scope="scope">
                  <div>{{scope.row.create_time|timestampToTime}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="service_code" label="服务单号" min-width="150" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <span style="color: #1989FA;cursor: pointer" @click="gotoAftersaleDetail(scope.row.id)">
                    {{scope.row.service_code}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="supply_seller_name" label="供应商名称" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_code" label="商品编码" width="150" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_name" label="产品名称" width="150" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="order_code" label="订单编号" width="150" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="num" label="售后数量" width="100" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="service_money" label="售后金额" width="100" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.service_money||scope.row.service_money==0">￥{{scope.row.service_money}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="service_type" label="服务类型" width="100" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.service_type==90">退货</div>
                  <div v-else-if="scope.row.service_type==91">挂账</div>
                  <div v-else-if="scope.row.service_type==93">代发退货</div>
                  <div v-else>维修</div>
                </template>
              </el-table-column>
              <el-table-column prop="process_status" label="售后处理状态" width="100" :show-overflow-tooltip='true'>
                <template slot-scope="scope">
                  <div v-if="scope.row.process_status==250">已取消</div>
                  <div v-else-if="scope.row.process_status==251">提交申请</div>
                  <div v-else-if="scope.row.process_status==252">审计</div>
                  <div v-else-if="scope.row.process_status==253">收货</div>
                  <div v-else-if="scope.row.process_status==254">退款</div>
                  <div v-else-if="scope.row.process_status==255">完成</div>
                  <div v-else-if="scope.row.process_status==256">出库</div>
                  <div v-else-if="scope.row.process_status==257">维修中</div>
                  <div v-else>待出货</div>
                </template>
              </el-table-column>
              <el-table-column prop="audit_status" label="审核状态" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.audit_status==260">未审核</div>
                  <div v-else-if="scope.row.audit_status==261">审核通过</div>
                  <div v-else>审核不通过</div>
                </template>
              </el-table-column>
              <el-table-column prop="audit_name" label="审核人" width="100">
              </el-table-column>
              <el-table-column prop="settle_status" label="结算状态" width="100">
                <template slot-scope="scope">
                  <div plain v-if="scope.row.settle_status==1">已结算</div>
                  <div plain v-else>未结算</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" min-width="150">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="enterForm(scope.row.id)"
                             v-if="scope.row.is_show_luru_btn">录入单号</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
        </el-tab-pane>
      </el-tabs>

      <el-dialog title="录入单号" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeDialog"
                 :visible.sync="flashInvoiceVisible" width="30%" top="15vh" center :modal="false" class="backRgba">
        <el-form label-width="120px" :model="flashForm" :rules="rules" ref="flashForm" class="delivery">
          <el-form-item label="快递公司" prop="receiver_delivery_company_id">
            <el-select v-model="flashForm.receiver_delivery_company_id" filterable placeholder="请选择快递公司" clearable>
              <el-option
                v-for="item in compDeliveryListData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" prop="receiver_delivery_no">
            <el-input size="small" v-model.trim="flashForm.receiver_delivery_no" auto-complete="off" maxLength="50" clearable
                      placeholder="请输入快递单号"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title"
                     @click="submitSendForm('flashForm')">
            确 认
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  expressType,
  addSend,
  orderSend,
  popularDeliveryList,
  deleteLabel,
  toMeList,
  toMeSettle,
  toSellerList,
  confirmReceipt, repairDelivery
} from '../../api/basisMG'
import Pagination from '../../components/Pagination'
import {timestampToDate} from "../../utils/util";
import {param} from "../../api/commonMG";

export default {
  data: () => {
    return {
      loading: false, //是显示加载
      flashInvoiceVisible: false,
      searchDate: '',
      searchDate1: '',
      formInline: {
        page: 1,
        rows: 10,
        supply_seller_id: "",
        supply_seller_name: "",
        settle_company_id: "",
        settle_company_name: "",
        begin_time: "",
        end_time: "",
        service_code: "",
        order_code: "",
        keywords: "",
        audit_status: "",
        process_status: "",
        settle_status: ""
      },
      formInline1: {
        page: 1,
        rows: 10,
        supply_seller_id: "",
        supply_seller_name: "",
        settle_company_id: "",
        settle_company_name: "",
        begin_time: "",
        end_time: "",
        service_code: "",
        order_code: "",
        keywords: "",
        audit_status: "",
        process_status: "",
        settle_status: ""
      },
      flashForm: {
        receiver_delivery_company_id: "",
        receiver_delivery_no: ""
      },
      service_id: "",
      // rules表单验证
      rules: {
        receiver_delivery_company_id: [{required: true, message: '请输入快递单号', trigger: 'change'}],
        receiver_delivery_no: [{required: true, message: '请输入快递公司', trigger: 'change'}],
      },
      listData: [], //用户数据
      listData1: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 分页参数
      pageparm1: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      positiontype: [],
      selectTableData: [],
      activeName: 'first',
      agent_type: localStorage.getItem('agent_type') || '2891',
      compDeliveryListData: [],
      sendId: '',
      submit_time: '',
      order_code: '',
      orderId: '',
      labelForm: {
        labelId: '',
        after_ids: []
      },
      after_ids: ''
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    // this.getdata1(this.formInline1)
  },
  mounted() {

  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      toSellerList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.content.rows
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.rows
            this.pageparm.total = res.content.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.rows = parm.pageSize
      this.getdata(this.formInline)
    },
    // 获取公司列表 1-1
    getdata1(parameter) {
      this.loading = true
      toMeList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData1 = res.content.rows
            // 分页赋值
            this.pageparm1.currentPage = this.formInline1.page
            this.pageparm1.pageSize = this.formInline1.rows
            this.pageparm1.total = res.content.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather1(parm) {
      this.formInline1.page = parm.currentPage
      this.formInline1.rows = parm.pageSize
      this.getdata1(this.formInline1)
    },
    handleClick(tab, event) {
      console.log(tab.index)
      if (tab.index == 0) {
        this.getdata(this.formInline)
      } else if (tab.index == 1) {
        this.getdata1(this.formInline1)
      }
    },
    // 查询事件
    search() {
      if (this.searchDate) {
        this.formInline.begin_time = timestampToDate(this.searchDate[0])
        this.formInline.end_time = timestampToDate(this.searchDate[1])
      } else {
        this.formInline.begin_time = ''
        this.formInline.end_time = ''
      }
      this.formInline.page = 1;
      this.getdata(this.formInline)
    },
    // 查询事件
    search1() {
      if (this.searchDate1) {
        this.formInline1.begin_time = timestampToDate(this.searchDate1[0])
        this.formInline1.end_time = timestampToDate(this.searchDate1[1])
      } else {
        this.formInline1.begin_time = ''
        this.formInline1.end_time = ''
      }
      this.formInline1.page = 1;
      this.getdata1(this.formInline1)
    },
    // 结算退货单
    getOrder() {
      if (this.selectTableData.length == 0) {
        this.$message.error('请选择一条数据再操作!');
        return
      }
      let hasInvalidStatus = false;
      if (this.selectTableData.some((item) => {
        if (item.settle_status == 0 && item.is_online == 0 &&!hasInvalidStatus) {
          return false;
        }
        this.$message.error('只能选择未结算的挂账订单退货单!');
        return true;
      })) {
        return;
      };
      this.labelForm.after_ids = []
      this.selectTableData.forEach((item) => {
        this.labelForm.after_ids.push(item.id)
      })
      const title = '是否对退货单进行结算？';
      this.$confirm(title, '结算退货单', {
        confirmButtonText: '确定结算',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        let obj = {
          after_ids: this.labelForm.after_ids
        }
        toMeSettle(obj)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功结算退货单!'
              });
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleSelectionChange(val) {
      this.selectTableData = val
    },
    //确认收货
    receiptForm(id) {
      var title = '是否确认收货'
      this.$confirm(title, '确认收货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        confirmReceipt(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '收货成功!'
              });
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 录入单号
    enterForm(id) {
      this.id = id;
      this.flashForm = {
        service_id: "",
        receiver_delivery_company_id: "",
        receiver_delivery_no: ""
      };
      this.flashInvoiceVisible = true;
      this.currentPage = 1;
      let data = {
        page: 0,
        rows: 10,
        name: ""
      }
      popularDeliveryList(data)
        .then(res => {
          if (res.success) {
            this.compDeliveryListData = res.content;
          }
        })
        .catch(err => {
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    //跳转服务单详情
    gotoAftersaleDetail(id) {
      localStorage.setItem('path', '/supply/supplySaleDetail')
      let tag = {
        url: "/supply/supplySaleDetail",
        menuname: "退货服务单详情"
      }
      this.$store.commit('selectMenu', tag)
      this.$router.push({path: '/supply/supplySaleDetail', query: {id: id}})
    },
    //确认
    submitSendForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.flashForm.service_id = this.id;
          this.loading = true;
          repairDelivery(this.flashForm)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功录入单号！'
                })
                this.closeDialog()
                this.getdata1(this.formInline1)
              }
            })
            .catch(err => {
              this.loading = false;
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.flashInvoiceVisible = false;
      this.$refs["flashForm"].resetFields();
    },
    //双击复制
    cellDbClick(row, column, cell, event) {
      if (row.order_code == cell.innerText || row.seller_name == cell.innerText || row.supply_seller_name == cell.innerText || row.service_code == cell.innerText || row.product_code == cell.innerText) {
        if (event.type === "dblclick") {
          var save = function (e) {
            e.clipboardData.setData('text/plain', cell.innerText);
            e.preventDefault();//阻止默认行为
          }
          document.addEventListener('copy', save);
          document.execCommand("copy");
          document.removeEventListener('copy', save);
        }
        this.$message({message: '复制成功', type: 'success'})
      }
    },
  }
}
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .delivery .el-input--small {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .userRole {
    width: 100%;
  }

  .flex_box {
    display: flex;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/views/supply/supplyReturn.vue